module.exports = __webpack_public_path__ + "static/media/homeButtonFilled.6639bd32.svg";